<template>
  <div class="edit-main-product">
    <b-modal 
      id="edit-main-product"
      ref="editMainProductRef"
      :hide-header="true"
      size="md">
      <form id="edit-main-product-form">
        <h5>价格编辑</h5>
        <div class="alert alert-success">
          <span>订单价格=基础价格*册数+(页数-基础P数)*册数＋包装费＋快递费</span><br>
          <span>订单总重量=产品净重 + (页数-基础P数) * 每P重量</span>
        </div>

        <div class="form-group row">
          <label class="col-md-4 col-form-label col-form-label-sm">产品名</label>
          <div class="col-md-8">
            <input type="text" readonly class="form-control form-control-sm" :value="product.name">
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-4 col-form-label col-form-label-sm">尺寸</label>

          <div class="input-group col input-group-sm">
            <div class="input-group-prepend">
              <div class="input-group-text">长</div>
            </div>
            <input type="text" class="form-control" name="height" placeholder="mm"
              v-model.number="product.meta.height" 
              v-validate="{ required: true, decimal: 2, min_value:0 }"
              :class="{'is-invalid': errors.has('height')}">
            <div class="input-group-append">
              <div class="input-group-text">mm</div>
            </div>
          </div>

          <div class="col-md-1">
            <input type="text" class="form-control-plaintext form-control-sm" readonly value="X">
          </div>
          
          <div class="input-group col input-group-sm">
            <div class="input-group-prepend">
              <div class="input-group-text">宽</div>
            </div>
            <input type="text" class="form-control" name="width"
              v-model.number="product.meta.width"
              v-validate="{ required: true, decimal: 2, min_value:0 }"
              :class="{'is-invalid': errors.has('width')}">
            <div class="input-group-append">
              <div class="input-group-text">mm</div>
            </div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-4 col-form-label col-form-label-sm ">产品净重</label>
          <div class="input-group col-md-8 input-group-sm">
            <input type="text" class="form-control" name="weight"
              v-model.number="product.meta.weight"
              v-validate="{ required: true, decimal: 4, min_value:0 }"
              :class="{'is-invalid': errors.has('weight')}">
            <div class="input-group-append">
              <span class="input-group-text">kg</span>
            </div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-4 col-form-label col-form-label-sm">邮费收取规则</label>
          <div class="input-group col-md-8 input-group-sm">
            <select class="custom-select" v-model="product.meta.delivery_fee">
              <option :value="'BY_WEIGHT'">按重量收取</option>
              <option :value="'FREE_OR_ELSE'">包邮或统一收取</option>
              <option :value="'BY_ORDER_COUNT'">按照订单个数收取</option>
              <option :value="'BY_ORDER_COUNT_NON_SF'">(非顺丰)按照订单数量收取</option>
              <option :value="'BY_BOOK_COUNT'">按照书本数量收取</option>
              <option :value="'BY_BOOK_COUNT_NON_SF'">(非顺丰)按照书本数量收取</option>
            </select>
          </div>
        </div>
         <div class="form-group row">
          <label class="col-md-8 col-form-label col-form-label-sm">按照订单数/册数收取邮费时的单价</label>
          <div class="input-group col-md-4 input-group-sm">
            <input type="text" class="form-control" name="fee_item"
              v-model.number="product.meta.delivery_fee_item"
              v-validate="{ required: true, decimal: 4, min_value:0 }"
              :class="{'is-invalid': errors.has('fee_item')}">
            <div class="input-group-append">
              <span class="input-group-text">元</span>
            </div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-4 col-form-label col-form-label-sm">基础P数</label>
          <div class="input-group col-md-8 input-group-sm">
            <input type="text" class="form-control" name="base-page-count"
              :class="{'is-invalid': errors.has('base-page-count')}"
              v-validate="{ required: true, min_value:0 }"
              v-model.number="product.meta.base_page_count">
            <div class="input-group-append">
              <div class="input-group-text">页</div>
            </div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-4 col-form-label col-form-label-sm">每P重量</label>
          <div class="input-group col-md-8 input-group-sm">
            <input type="text" class="form-control" name="page-weight"
              :class="{'is-invalid': errors.has('page-weight')}"
              v-validate="{ required: true, min_value:0, decimal: 4 }"
              v-model.number="product.meta.page_weight">
            <div class="input-group-append">
              <div class="input-group-text">kg</div>
            </div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-4 col-form-label col-form-label-sm">加P价格</label>
          <div class="input-group col-md-8 input-group-sm">
            <input type="text" class="form-control form-control-sm" name="fee-extra-charge"
              :class="{'is-invalid': errors.has('fee-extra-charge')}"
              v-validate="{ required: true, decimal:4 }"
              v-model.number="product.meta.fee_extra_page">
            <div class="input-group-append">
              <span class="input-group-text">元</span>
            </div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-4 col-form-label col-form-label-sm">包装费</label>
          <div class="input-group col-md-8 input-group-sm">
            <input type="text" class="form-control form-control-sm" name="fee-packing"
              :class="{'is-invalid': errors.has('fee-packing')}"
              v-validate="{ required: true, decimal:4 }"
              v-model.number="product.meta.fee_packaging" placeholder="客户自己提供包装的，此项写0">
            <div class="input-group-append">
              <div class="input-group-text">元</div>
            </div>
          </div>
        </div>
        <div class="form-group row">
          <label class="col-md-4 col-form-label col-form-label-sm">基础价格</label>
          <div class="input-group col-md-8 input-group-sm">
            <input type="text" class="form-control form-control-sm" :value="fee_base" readonly>
            <div class="input-group-append">
              <div class="input-group-text">元</div>
            </div>
          </div>
        </div>
        <hr/>
        <div class="row">
          <div class="col-md-2"></div>
          <div id="extra-items" class="col-md-10">
            <div class="extra-item" v-for="(item, index) in fee_base_items">

              <div class="form-group row">
                <div class="col-sm-5">
                  <input type="text" class="form-control form-control-sm" :name="'base-item-key-' + index"
                    :class="{'is-invalid': errors.has('base-item-key-' + index)}"
                    v-validate="{ required: true, min: 1 }"
                    v-model.trim="item[0]">
                </div>
                <div class="input-group col input-group-sm">
                  <input type="text" class="form-control form-control-sm" :name="'base-item-value-' + index"
                    :class="{'is-invalid': errors.has('base-item-value-' + index)}"
                    v-validate="{ required: true, min_value:0, decimal:4 }"
                    v-model.number="item[1]">
                  <div class="input-group-append">
                    <div class="input-group-text">元</div>
                  </div>
                </div>
                <div class="col">
                  <label class="col-form-label col-form-label-sm" @click="deleteFromeBasePrice(index)">
                    <i class="fa fa-trash text-danger"></i>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group row">
          <label class="col-md-4 col-form-label col-form-label-sm">附件价格</label>
        </div>
        <hr/>
        <div class="row">
          <div class="col-md-2"></div>
          <div id="extra-items" class="col-md-10">
            <div class="extra-item" v-for="(item, index) in fee_extra_items">

              <div class="form-group row">
                <div class="col-sm-5">
                  <input type="text" class="form-control form-control-sm" :name="'extra-item-key-' + index"
                    :class="{'is-invalid': errors.has('extra-item-key-' + index)}"
                    v-validate="{ required: true, min: 1 }"
                    v-model.trim="item[0]">
                </div>
                <div class="input-group col input-group-sm">
                  <input type="text" class="form-control form-control-sm" :name="'extra-item-value-' + index"
                    :class="{'is-invalid': errors.has('extra-item-value-' + index)}"
                    v-validate="{ required: true, min_value:0, decimal:4 }"
                    v-model.number="item[1]">
                  <div class="input-group-append">
                    <div class="input-group-text">元/个</div>
                  </div>
                </div>
                <div class="col">
                  <label class="col-form-label col-form-label-sm" @click="deleteFromeBasePrice(index)">
                    <i class="fa fa-trash text-danger"></i>
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>

      </form>
      <div slot="modal-footer" class="w-100">
        <button class="btn btn-sm btn-secondary float-right" @click="$refs.editMainProductRef.hide();">取消</button>
        <button class="btn btn-sm btn-primary float-right mx-2" id="submit-pre-charge" @click="submitEditProduct">提交</button>
        <button class="btn btn-sm btn-primary float-right mx-2" id="submit-pre-charge" @click="addToBasePrice">添加基础价格项</button>
        <button class="btn btn-sm btn-primary float-right mx-2" id="submit-pre-charge" @click="addToExtraItems">添加附件价格</button>
      </div>
    </b-modal>
  </div>
</template>

<script>
function showEditMainProductModal (product) {
  this.product = product
  this.fee_base_items = product.meta.fee_base_items
  this.fee_extra_items = product.meta.fee_extra_items || []
  this.$refs.editMainProductRef.show()
}

function addToBasePrice () {
  this.fee_base_items.push(['', 0])
}

function deleteFromeBasePrice (index) {
  let item = this.fee_base_items[index]
  if (!confirm(`确定删除 ${item[0]} 吗?`)) {
    return
  }
  this.fee_base_items.splice(index, 1)
}

function addToExtraItems () {
  this.fee_extra_items.push(['', 0])
}

function deleteFromeExtraItem (index) {
  let item = this.fee_extra_items[index]
  if (!confirm(`确定删除 ${item[0]} 吗?`)) {
    return
  }
  this.fee_extra_items.splice(index, 1)
}

function submitEditProduct () {
  this.$validator.validateAll().then((result) => {
    if (!result) {
      return
    }
    let meta = this.product.meta
    meta.fee_base_items = this.fee_base_items
    meta.fee_extra_items = this.fee_extra_items

    this.$http.put(`/api/main_products/${this.product.product_code}/meta`, meta).then(response => {
      setTimeout(() => {
        this.$emit('refresh')
        this.$refs.editProductRef.hide()
      }, 500)
    })
  })
}

export default {
  name: 'edit-main-product',
  data () {
    return {
      product: {
        meta: {}
      },
      fee_base_items: [],
      fee_extra_items: []
    }
  },
  computed: {
    fee_base: function () {
      let result = this.fee_base_items.reduce(function (preVal, element) {
        return preVal + element[1]
      }, 0)

      return Math.round(result * 100, 2) / 100
    }
  },
  methods: {
    showEditMainProductModal,
    addToBasePrice,
    addToExtraItems,
    deleteFromeBasePrice,
    deleteFromeExtraItem,
    submitEditProduct
  }
}
</script>

<style lang="scss">
.form-group {
  margin-bottom: 0.3em
} 
</style>
